import moment from 'moment-timezone'

export const userTimeZone = () => Intl.DateTimeFormat().resolvedOptions().timeZone || moment.tz.guess()
